import React from 'react'
import { Input } from 'semantic-ui-react'

const KEY_ENTER = 13
const KEY_ESC = 27

export default class EditActionSeconds extends React.Component {
    state = { seconds: 10 }

    componentDidUpdate(prevProps) {
        if (prevProps.seconds !== this.props.seconds)
            this.reset()
    }

    componentDidMount() {
        this.reset()
    }

    reset() {
        this.setState({ seconds: this.props.seconds })
    }

    save = () => {
        const { seconds } = this.state
        if (!seconds || isNaN(seconds))
            return this.reset()
        this.props.onSubmit(seconds)
        this.inputRef.inputRef.blur()
    }

    handleInputRef = (ref) => this.inputRef = ref
    handleValueChange = (e, { name, value }) => this.setState({ [name]: value })
    handleKeyDown = (e) => {
        switch (e.which) {
            case KEY_ENTER:
                e.preventDefault()
                e.stopPropagation()
                this.save()
                break

            case KEY_ESC:
                this.reset()
                this.inputRef.inputRef.blur()
                break

            default:
                break
        }
        
    }

    render() {
        const { seconds } = this.state
        const { label } = this.props

        return (
            <div>
                Tempo {label}: <Input name='seconds' 
                    value={seconds} 
                    onChange={this.handleValueChange} 
                    onKeyDown={this.handleKeyDown}
                    onBlur={this.save}
                    ref={this.handleInputRef} /> secondi
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/EditActionSeconds.js